import { forwardRef } from 'react';
import styled from 'styled-components';
import { space } from 'styled-system';
import { HTMLKaajaProps } from '../../types';

type LabelProps = HTMLKaajaProps<'label'>;

const Styled = styled('label')<LabelProps>(
  (props) => ({
    fontWeight: 600,
    display: 'block',
    fontSize: props.theme.fontSizes[1],
    color: props.theme.colors.neutral900,
  }),
  space
);

const Label = forwardRef<HTMLLabelElement, LabelProps>((props, ref) => {
  return <Styled ref={ref} {...props} />;
});

export { Label };
